jQuery(document).ready(function($) {


	// ---------------------------------------------------------------------
	// | modal video                                                       |
	// ---------------------------------------------------------------------
	if ($('.js-modal-video').length) {
		var $modal = $('.js-modal-video');
		var $modalContent = $('.js-modal-video-content');

		var launchVideo = function($trigger) {
			var type = $trigger.attr('data-type');
			var src = $trigger.attr('data-src');
			var $html5Vid = $trigger.next('.js-modal-video-player-html5');

			$modalContent.empty();

			if (type === 'html5') {
				// html markup must be in markup, not added dynamically because of video bindings in the browser
				$html5Vid.clone(true).appendTo($modalContent).toggleClass('hidden js-modal-video-player-html5 js-modal-video-player');
			} else if (type === 'youtube') {
				var html = '<div class="video-player js-modal-video-player" data-type="youtube" data-video-id="' + src + '"></div>';
				$modalContent.append(html);
			} else if (type === 'vimeo') {
				var html = '<div class="video-player js-modal-video-player" data-type="vimeo" data-video-id="' + src + '"></div>';
				$modalContent.append(html);
			}

			var player = plyr.setup('.js-modal-video-player', {
				autoplay: true,
				controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume']
			});

			if ($('.js-modal-video-player').attr('data-type') === 'youtube') {
				var url = $('.js-modal-video-player iframe').attr('src');
				$('.js-modal-video-player iframe').attr('src', url + '?playsinline=1');
			}

			$modal.on('hide.bs.modal', function() {
				player[0].stop();
			});
		};

		// add modal content and init plyr on button click
		$('.js-modal-video-trigger').each(function() {
			$(this).on('click', function() {
				launchVideo($(this));
			});
		});

	}
});
